import { ActionBar } from "../components/dashboard/ActionBar"
import { LabReportsTable } from "../components/dashboard/LabReportsTable"
import { PatientsTable } from "../components/dashboard/PatientsTable"

export const DashboardPage = () => {
  return (
    <div className="flex flex-col gap-y-4">
      <ActionBar />
      <div className="3xl:grid-cols-2 grid grid-cols-1 gap-4">
        <LabReportsTable />
        <PatientsTable />
      </div>
    </div>
  )
}
